import React from "react";
import crossedEye from "icons/icon-hide.svg";
import info from "icons/info.svg";
import { calculateThemeFrequencyByDoc } from "utils/discovery";
import { expandCollapse } from "slices/discovery/discoverySlice";
import Gradient from "components/Gradient";
import { TooltipTrigger } from "@visiblethread/react-components/dist/components/Tooltip";

function getTooltip(isExcel) {
  return (
    <div className="gradient__info">
      <TooltipTrigger
        content={
          isExcel
            ? "Discovery does not support Excel files"
            : "This file contains no text"
        }
      >
        <img src={info} alt="info" style={{ height: "18px" }} />
      </TooltipTrigger>
    </div>
  );
}

function getDocListBodyEyeImg() {
  return (
    <div className="gradient__eye">
      <img src={crossedEye} alt="ignored" style={{ height: "18px" }} />
    </div>
  );
}

const getDocListBodyHitsCol = (
  docWithHits,
  rowIndex,
  isSearch,
  filterView,
  isTheme,
  minMax,
  freq
) => {
  let occurrences = 0;
  if (freq !== undefined) {
    occurrences = freq;
  } else if (isSearch && isTheme) {
    occurrences = docWithHits.Search.Occurrences;
  } else if (filterView && isTheme) {
    occurrences = docWithHits.Filter.Occurrences;
  } else {
    occurrences = docWithHits.Occurrences;
  }

  return <Gradient content={occurrences} maxOccurrences={minMax.max} />;
};

const getDocListBodyNoHitsCol = (document, rowIndex) => {
  const isEmpty = document.Occurrences === 0;
  const isExcel = /\.xls[xmb]?$/.test(document.Name);

  if (rowIndex === 0 && (isEmpty || isExcel)) {
    return getTooltip(isExcel);
  }

  if (rowIndex === 0 && document.ignored) {
    return getDocListBodyEyeImg();
  }

  return <Gradient content={0} maxOccurrences={0} />;
};

export const getDocListBodyColumns = (
  themeList,
  theme,
  rowIndex,
  docs,
  isSearch,
  filterView,
  showAll,
  minMax
) => {
  return docs?.map((document) => {
    const docWithHits = theme.Documents.find((doc) => doc.Id === document.Id);
    const isTheme = !theme.NounPhrase;

    if (
      docWithHits !== undefined &&
      !docWithHits.ignored &&
      !document.disabled
    ) {
      if ((isSearch || filterView || !showAll) && isTheme) {
        const freq = calculateThemeFrequencyByDoc(
          themeList,
          theme,
          showAll,
          isSearch,
          docWithHits
        );

        getDocListBodyHitsCol(
          docWithHits,
          rowIndex,
          isSearch,
          filterView,
          isTheme,
          minMax,
          freq
        );
      }
      return getDocListBodyHitsCol(
        docWithHits,
        rowIndex,
        isSearch,
        filterView,
        isTheme,
        minMax
      );
    }
    return getDocListBodyNoHitsCol(document, rowIndex);
  });
};

export const manageExpandCollapse = (dispatch, setHover) => {
  if (document.getElementsByClassName("Pane1")?.[0].offsetWidth > 350) {
    document.getElementsByClassName("Pane1")[0].style.width = "350px";
    dispatch(expandCollapse({ type: "RESET" }));
  } else {
    document.getElementsByClassName("Pane1")[0].style.width = "200px";
    dispatch(expandCollapse({ type: "DOCS", collapsed: true }));
    dispatch(expandCollapse({ type: "CONTENT", collapsed: false }));
  }
  setHover(false);
};
